import { render, staticRenderFns } from "./userBirthday.vue?vue&type=template&id=480b0e18&scoped=true&"
import script from "./userBirthday.vue?vue&type=script&lang=js&"
export * from "./userBirthday.vue?vue&type=script&lang=js&"
import style0 from "./userBirthday.vue?vue&type=style&index=0&id=480b0e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480b0e18",
  null
  
)

export default component.exports